/*@ngInject*/
const ProposalMediator = function (proposalRepository,proposalListRepository) {
    this.sendProposal = function (proposalId) {
        return proposalRepository.sendProposal(proposalId);
    };

    this.getProposalList = function (submissionId, accountId) {
        return proposalListRepository.getProposalList(submissionId, accountId);
    };

    this.findById = function (proposalId) {
        return proposalRepository.findById(proposalId);
    };

    this.getSections = function (proposalId) {
        return proposalRepository.getSections(proposalId);
    };

    this.stitchSections = function (proposalId, sectionType) {
        return proposalRepository.stitchSections(proposalId, sectionType);
    };

    this.updateSection = function (sectionId, stitchable) {
        return proposalRepository.updateSection(sectionId, stitchable);
    };

    this.moveSection = function (sectionId, proposalOrdinalNumber) {
        return proposalRepository.moveSection(sectionId, proposalOrdinalNumber);
    };
};

angular.module('gw-um-submission')
    .service('proposalMediator', ProposalMediator);
